import getRestaurant from '@menu/Utils/getRestaurant';

function getLocalStorageKey() {
  return `menuLanguage-${getRestaurant().id}`;
}

function getPreferredLanguage(): string {
  let languageFromLocalStorage: string | null = null;

  try {
    languageFromLocalStorage = localStorage.getItem(getLocalStorageKey());
  } catch (e) {
    // because sometimes `SecurityError: The operation is insecure.` happens
  }

  // todo: refactor
  try {
    if (!languageFromLocalStorage) {
      languageFromLocalStorage = window.navigator.language.slice(0, 2);
    }
  } catch (e) {
    //
  }

  return (
    getRestaurant().languages.find(
      (lang) => lang === languageFromLocalStorage,
    ) ?? getRestaurant().languages[0]
  );
}

function setPreferredLanguage(languageCode: string) {
  try {
    localStorage.setItem(getLocalStorageKey(), languageCode);
  } catch (e) {
    // because sometimes `SecurityError: The operation is insecure.` happens
  }
}

export { getPreferredLanguage, setPreferredLanguage };
